'use strict';

/**
 * @author Maxim Seredkin
 */

export default ['$scope', '$routeParams', '$window', 'AreaService',
                function($scope, $routeParams, $window, AreaService) {
                    $scope.areas = [];
                    AreaService.api.get({
                                            filters: [`'status' EQ 'ENABLED'`],
                                            sorts: ['npp:ASC', 'name:ASC'],
                                        }, (data) => $scope.areas = data._embedded);
                }];
